import { IBrand } from 'data/schema';
import { normalizeShowroomConfigId } from 'utils/ui/showroomConfigId';

export function injectShowroom({ onLoad = () => {} }: { onLoad: (result: boolean) => void }) {
  const scriptId = 'avp-3dws-deck-script';
  const existingScript = document.getElementById(scriptId);

  if (!existingScript && import.meta.env.MODE !== 'test') {
    const script = document.createElement('script');
    script.type = 'module';
    script.src = 'https://avp-3dws-deck.eu-west-1-web-streaming.avp.tech/avp-3dws-deck.js';
    script.id = scriptId;
    script.onload = () => onLoad(true);
    document.head.appendChild(script);
  } else {
    onLoad(true);
  }
}

/**
 * Resolves the deck `config-id`. Precedence (AVS-4477):
 * 1. a non-blank `showroomConfigId` override, returned untrimmed and unvalidated (unknown ids pass through),
 * 2. the Audi scheduler config for a scheduled Audi session,
 * 3. the brand default.
 * An empty or whitespace-only override means "no override".
 */
export function getShowroomConfig(brand: IBrand, isScheduledSession = false, showroomConfigId?: string): string {
  const override = normalizeShowroomConfigId(showroomConfigId);
  if (override) {
    return override;
  }

  const showroomConfigs: Record<IBrand, string> = {
    A: isScheduledSession ? 'a-3DExhibition-scheduler-2025' : 'a-3DExhibition-default-2025',
    V: 'v-3DExhibition-default-2025',
    S: 'c-3DExhibition-default-2025',
    C: 'c-3DExhibition-default-2025',
    E: 'bentley-default',
    L: 'l-3DExhibition-default-2025',
    M: 'ngc-default',
    N: 'n-3DExhibition-default-2025',
    P: 'ngc-default',
    '*': 'a-3DExhibition-default-2025',
  };

  return showroomConfigs[brand] || showroomConfigs['*'];
}
